import { Icon } from "../../../../../../Elements/Icon";

import * as styles  from "./styles.module.scss";

export const TrackListItem = ({ track, current, onSelect }) => {
    return (
        <button
            type="button"
            className={styles.item}
            aria-current={current}
            onClick={() => onSelect(track.number)}
        >
            <div className={styles.number}>
                <Icon name="play" width="12" height="14" />

                <span>{track.number}</span>
            </div>

            <div className={styles.title}>{track.name}</div>
        </button>
    );
};
